<template>
  <v-row no-gutters>
    <v-col cols="12" sm="10" offset-sm="1">
      <span class="headline">Gradovi</span>
      <bit-page :breadcrumbs="breadcrumbs"></bit-page>

      <v-form ref="form">
        <v-row align="center" class="white mt-3 pa-3" no-gutters>
          <v-col cols="12" sm="6" class="px-2">
            <v-text-field
                    v-model="selectedItem.name"
                    dense
                    label="Naziv"
                    outlined
                    :rules="fieldRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="px-2">
            <v-text-field
                    v-model="selectedItem.email"
                    dense
                    label="Email"
                    outlined
                    :rules="fieldRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="px-2">
            <v-text-field
                    v-model="selectedItem.password"
                    dense
                    label="Sifra"
                    outlined
                    :rules="fieldRules"
            ></v-text-field>
          </v-col>


          <!-- // NOVA POLJA-->
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" class="px-2 mt-4">
            <v-tabs v-model="tab" background-color="primary" dark height="40">
              <v-tab v-for="item in selectedItem.langs" :key="item.id">
                {{ item.lang.name }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="item in selectedItem.langs" :key="item.id">
                <v-card>
                  <v-card-text>
                    <v-row no-gutters>

                      <v-col cols="12" sm="6" class="px-2">
                        <v-text-field
                                v-model="item.name"
                                dense
                                label="Naziv"
                                outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>

          <v-col cols="12" class="mt-2">
            <v-row justify="center">
              <v-btn color="primary" tile depressed @click="save">Snimi</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
  import bitPage from "../../../components/layout/page";
  //import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import {Datetime} from 'vue-datetime';
  import config from '../../../config';
  import { db } from '../../../firebase';
  import axios from 'axios';

  export default {
    components: {
      bitPage,
      datetime: Datetime
    },
    head() {
      return {
        title: 'BitLab CMS'
      }
    },
    data: () => ({
      config: config,
      breadcrumbs: [
        {
          text: 'Objekti',
          disabled: false,
          to: {name: 'objekti'},
        },
        {
          text: 'Dodavanje novog grada',
          disabled: true
        },
      ],
      items: [],
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      //editor: ClassicEditor,
      editorData: '<p>Rich-text editor content.</p>',
      editorConfig: {
        extraPlugins: 'justify'
      },
      selectedItem: {
        position: null,
        parent_id: null,
        extra_fields: [],
        langs: [],
        email: null,
        password: null,
        user_id: null
      },
      tab: null,
      categories: [],
      fieldRules: [
        v => !!v || 'Field is required'
      ],
      previewImage: null,
      album: [],
      objects: [],
      notification: false
    }),
    firestore() {
      return {
        objects: db.collection('objects'),
      }
    },
    created() {
      if (this.$route.params.item) {
        this.selectedItem = this.$route.params.item;
        this.getLangs();
        this.selectedItem.langs.forEach(lang => {
          return lang.keywords = lang.keywords && lang.keywords.split(',')
            ? lang.keywords.split(',') : []
        })

        this.selectedItem.include_in_layout = this.selectedItem.include_in_layout && this.selectedItem.include_in_layout.split(',')
          ? this.selectedItem.include_in_layout.split(',') : []

      } else {
        this.getLangs();
      }
    },
    methods: {
      getLangs() {
        this.$store.dispatch('GET_LANGUAGES').then(res => {
          console.log(res)
          res.forEach(lang => {
            let check = this.selectedItem.langs.find(item => item.lang_id === lang.id)
            if(!check) {
              this.selectedItem.langs.push({
                name: null,
                lang: lang,
                lang_id: lang.id
              })
            }
          })
        })
      },
      save() {
        if(this.$refs.form.validate()) {

          let data = new FormData();
          data.append('item', JSON.stringify(this.selectedItem));

          if (this.$route.params.item && !this.$route.params.sub) {
            data.append('_method', 'PUT');
            this.axios.post(`/sellers/${this.$route.params.item.id}`, data).then(res => {
              this.$router.push({name: 'distribucija-gradovi'})
            })
          } else {
            this.axios.post(`/sellers`, data).then(res => {
              this.$router.push({name: 'distribucija-gradovi'})
            })
          }

        }
        else {
          this.$vuetify.goTo(0, [])
        }
      }
    },
    computed: {
      setLang() {
        return this.$store.state.lang.code === 'en'
          ? 'en' : this.$store.state.lang.code === 'la'
            ? 'sr' : 'ћи'
      }
    }
  }
</script>
